import React, { useMemo, useContext, useState } from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';
import { AppContext, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';
import { useTranslation } from 'react-i18next';

const dataProviderName = 'renters/manageableinstalled';

const Default = () => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    const [filters, setFilters] = useState()


    const { userCapabilities } = useContext(AppContext);

    const now = new Date();
    const startPreviousYear = (now.getFullYear() - 1) + '-01-01';
    const startYear = now.getFullYear() + '-01-01';
    const startPreviousMonth = now.getFullYear() + '-' + String(now.getMonth()).padStart(2, '0') + '-01';
    const startMonth = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-01';

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">

            <KPI
                title="Total"
                icon="faEnvelopeCircleCheck"
                dataProviderName={'renters/manageableinstalled/statistic/total'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{

                    }]
                }}
            />

            <KPI
                title="Arval"
                icon="faEnvelopeCircleCheck"
                dataProviderName={'renters/manageableinstalled/statistic/count'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "contract.renter.name",
                        operator: "equals",
                        value: "Arval"
                    }]
                }}
            />

            <KPI
                title="Leasys"
                icon="faEnvelopeCircleCheck"
                dataProviderName={'renters/manageableinstalled/statistic/count'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "contract.renter.name",
                        operator: "equals",
                        value: "Leasys"
                    }]
                }}
            />

            <KPI
                title="Ayvens"
                icon="faEnvelopeCircleCheck"
                dataProviderName={'renters/manageableinstalled/statistic/count'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "contract.renter.name",
                        operator: "in",
                        value: ["Ayvens", "ALD Automative Italia S.r.l. a socio unico", "ALD Automotive Italia Srl", "ALD Automotive Italia S.r.L. a socio unico", "LeasePlan Italia S.p.A."]
                    }]
                }}
            />

            <KPI
                title="Others"
                icon="faEnvelopeCircleCheck"
                dataProviderName={'renters/manageableinstalled/statistic/count'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "contract.renter.name",
                        operator: "nin",
                        value: ["Arval", "Leasys", "Ayvens", "ALD Automative Italia S.r.l. a socio unico", "ALD Automotive Italia Srl", "ALD Automotive Italia S.r.L. a socio unico", "LeasePlan Italia S.p.A."]
                    }]
                }}
            />
        </Box>
        <List />

    </>, [])

}

export default Default;


